import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { post } from "../../../../helpers/api_helper";
import toast from "react-hot-toast";
import CKEditorComponent from "../../../../components/CKeditor/Ckeditor";
import { uploadPlugin } from "../../../../helpers/common";
import { useSelector } from "react-redux";
import useCheckPermission from "../../../../hooks/useCheckPermission";

const RefundPolicy = ({ content, onUpdate, pageId, pageName }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editorData, setEditorData] = useState(content);

  useEffect(() => {
    setEditorData(content);
  }, [content]);

  const handleEdit = async () => {
    if (isEditing) {
      try {
        const response = await post(`/pages/${pageName}`, {
          status: "active",
          name: pageName,
          content: editorData,
        });
        if (response?.success) {
          onUpdate(editorData);
          toast.success("Refund policy updated Successfully");
        } else {
          console.log(response.data.message || "Failed to update refund policy");
          toast.error(response.data.message || "Failed to update refund policy");
        }
      } catch (error) {
        console.error("Error updating content:", error);
      }
    }
    setIsEditing(!isEditing);
  };

  return (
    <div>
      <div className="d-flex align-items-center gap-10 btnWrpperGroup mt-3 pb-3">
        {useCheckPermission("content", "UPDATE") && <Button
          onClick={handleEdit}
          className="d-inline-flex align-items-center justify-content-center commonBtn w-10"
        >
          {isEditing ? "Save" : "Edit"}
        </Button>}
      </div>
      {isEditing ? (
        <CKEditorComponent
          content={editorData}
          onChange={(data) => setEditorData(data)}
          uploadPlugin={uploadPlugin}
        />
      ) : (
        <div dangerouslySetInnerHTML={{ __html: editorData }} />
      )}
    </div>
  );
};

export default RefundPolicy;
